import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    thumbnail: PropTypes.string,
    templateGroupType: PropTypes.string,
  },
  {
    thumb(tg) {
      return this.thumbnail(tg);
    },
    allCardsCount(items) {
      return items && items.length;
    },
  },
);
